import { useTranslation } from 'react-i18next';
import Icon from '__components/Kizen/Icon';
import {
  Container,
  StyledHeader as Header,
  StyledInfoBox as InfoBox,
  StyledParagraph,
  StyledIconsContainer,
  StyledContactIcon,
  StyledCard as Card,
} from './styles';
import { useSetTitleOnLoad } from 'hooks/useSetTitleOnLoad';
import { Spacer } from '@kizen/kds/Spacer';
import { Typography } from '@kizen/kds/Typography';
import { useSelector } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { isBusinessEnabled } from 'routes/auth';

export default function Inactive() {
  const { t } = useTranslation();

  const chosenBusiness = useSelector(
    (s: any) => s?.authentication?.chosenBusiness
  );

  const isEnabled = isBusinessEnabled(chosenBusiness);

  useSetTitleOnLoad(t('Your Business is Inactive'));

  if (isEnabled) {
    return <Redirect to="/" />;
  }

  return (
    <Container>
      <Card>
        <Header type="header" margin="lg">
          {t('Your Business is Inactive')}
        </Header>
        <InfoBox>
          <StyledParagraph>
            {t(
              "{{name}} does not have an active license. If you believe this is an error, or if you'd like to reactivate your account, please contact Kizen support.",
              {
                name: chosenBusiness?.name ?? t('This business'),
              }
            )}
          </StyledParagraph>
        </InfoBox>
        <StyledIconsContainer>
          <StyledContactIcon href="mailto:Support@Kizen.com">
            <Icon icon="envelope" color="var(--color-background-darker)" />
            <span>{t('Support@Kizen.com')}</span>
          </StyledContactIcon>
        </StyledIconsContainer>
        <StyledIconsContainer>
          <div className="flex">
            <Link to="/logout">
              <Typography variant="link">{t('Logout')}</Typography>
            </Link>
            <Spacer size={30} mode="vertical" />
            <Link to="/choose-business">
              <Typography truncate>{t('Switch Business')}</Typography>
            </Link>
          </div>
        </StyledIconsContainer>
      </Card>
    </Container>
  );
}
